import { useEffect, useState } from 'react';
import { Link } from '@framework/router/Next/Link';
import URL from '@/creditflowresearch/Router/urlConstants';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import PopoverTip from '@/creditflowresearch/ui/common/components/molecules/PopoverTip';

import styles from './localTimeZoneTip.module.scss';

interface IProps {
  /** Both occupy the same corner as the profile menu — expanding it dismisses the tip
   * for good, the same as clicking its own close button, not just hiding it while open. */
  isHidden?: boolean,
}

const LocalTimeZoneTip = ({ isHidden }: IProps): React.ReactElement | null => {
  const { isTimeZoneJustDetected, isAutoDetectEnabled } = useUserTimeZoneContext();
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    if (isHidden) setIsClosed(true);
  }, [isHidden]);

  const shouldShow = isAutoDetectEnabled && isTimeZoneJustDetected;

  if (!shouldShow || isClosed || isHidden) return null;

  return (
    <PopoverTip
      dataTest="localTimeZoneTip"
      closeDataTest="localTimeZoneTipClose"
      title="Local Time Zone Update"
      closeAriaLabel="Close notification"
      onClose={ () => setIsClosed(true) }
    >
      CreditFlow now displays dates and times in your local time zone. Manage this in{ ' ' }
      <Link
        to={ URL.SETTINGS }
        dataTest="localTimeZoneTipSettingsLink"
        className={ styles.link }
      >
        Settings
      </Link>.
    </PopoverTip>
  );
};

export default LocalTimeZoneTip;
